
import { Link } from "react-router-dom"

export default function Banner() {
	return (
		<>

			<div className="tf-widget-banner">
				<div className="themeflat-container">
					<div className="tf-banne-paralax">
						<h2 className="title-banner wow fadeInUp animated ">
							Hisoratra anarana
						</h2>
						<span className="sale wow fadeInUp animated "> Hetsika milay Fandriana 2025</span>
						<img src="images/retinal/runclub.png" alt="runclub" className="wow fadeInUp animated" />
						<Link to="/contact" className="flat-button wow fadeInUp animated ">Hanaraka ny Hetsika</Link>
					</div>
				</div>
			</div>
		</>
	)
}
